// extracted by mini-css-extract-plugin
export default {"loadingCenter":"loading_loadingCenter__qpFSx"};